import type { I18nService } from '../services/i18n';

type I18nArgs = {
    nameArgs: [resourceKey: string, defaultValue: string];
    shortNameArgs: [resourceKey: string, defaultValue: string];
};

// Структура данных для периодов спортивных событий
// Каждый период имеет название, параметры для локализации и список sportTypeId

export const SPORT_PERIODS: Record<string, I18nArgs & { sportTypeIds: number[] }> = {
    time: {
        nameArgs: ['Sport.PeriodTime', 'Тайм'],
        shortNameArgs: ['Sport.PeriodTimeShort', 'Т'],
        sportTypeIds: [17, 5, 7, 10, 79, 80, 38],
    },
    set: {
        nameArgs: ['Sport.PeriodSet', 'Сет'],
        shortNameArgs: ['Sport.PeriodSetShort', 'С'],
        sportTypeIds: [1, 9, 138, 19],
    },
    quarter: {
        nameArgs: ['Sport.PeriodQuarter', 'Четверть'],
        shortNameArgs: ['Sport.PeriodQuarterShort', 'Ч'],
        sportTypeIds: [2, 15, 44, 70],
    },
    party: {
        nameArgs: ['Sport.PeriodParty', 'Партия'],
        shortNameArgs: ['Sport.PeriodPartyShort', 'П'],
        sportTypeIds: [11, 29, 30, 40, 16, 32, 37, 12, 4],
    },
    inning: {
        nameArgs: ['Sport.PeriodInning', 'Иннинг'],
        shortNameArgs: ['Sport.PeriodInningShort', 'И'],
        sportTypeIds: [14, 21, 25],
    },
    frame: {
        nameArgs: ['Sport.PeriodFrame', 'Фрейм'],
        shortNameArgs: ['Sport.PeriodFrameShort', 'Ф'],
        sportTypeIds: [41, 6],
    },
    end: {
        nameArgs: ['Sport.PeriodEnd', 'Энд'],
        shortNameArgs: ['Sport.PeriodEndShort', 'Э'],
        sportTypeIds: [8],
    },
} as const;

// Карта для быстрого поиска аргументов локализации по sportTypeId
const SPORT_TYPE_ID_TO_I18N_ARGS = new Map<number, I18nArgs>();

// Заполнение карты при инициализации модуля
Object.values(SPORT_PERIODS).forEach((period) => {
    period.sportTypeIds.forEach((sportTypeId) => {
        SPORT_TYPE_ID_TO_I18N_ARGS.set(sportTypeId, {
            nameArgs: period.nameArgs,
            shortNameArgs: period.shortNameArgs,
        });
    });
});

function getI18nArgsBySportTypeId(sportTypeId: number): I18nArgs | undefined {
    return SPORT_TYPE_ID_TO_I18N_ARGS.get(sportTypeId);
}

function getSportPeriodShortName(sportTypeId: number, i18n: I18nService): string {
    const i18nArgs = getI18nArgsBySportTypeId(sportTypeId);
    
    if (!i18nArgs) return '';

    return i18n.$t(...i18nArgs.shortNameArgs);
}

function getSportPeriodFullName(sportTypeId: number, i18n: I18nService): string {
    const i18nArgs = getI18nArgsBySportTypeId(sportTypeId);

    if (!i18nArgs) return '';

    return i18n.$t(...i18nArgs.nameArgs);
}

export { getSportPeriodShortName, getSportPeriodFullName };
